import { stateConstants } from "../_constants";

const initialState = {
  states: null,
  currentState: null,
  allStatesLoading: false,
  allStatesError: null,
  addStateLoading: false,
  addStateError: null,
  viewStateLoading: false,
  viewStateError: null,
  editStateLoading: false,
  editStateError: null,
};

const {
  GET_ALL_STATES_START,
  GET_ALL_STATES_SUCCESS,
  GET_ALL_STATES_FAILED,
  ADD_STATE_START,
  ADD_STATE_END,
  ADD_STATE_FAILED,
  VIEW_STATE_START,
  VIEW_STATE_SUCCESS,
  VIEW_STATE_FAILED,
  EDIT_STATE_START,
  EDIT_STATE_END,
  EDIT_STATE_SUCCESS,
  EDIT_STATE_FAILED,
} = stateConstants;

export default function stateReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_STATES_START:
      return {
        ...state,
        allStatesLoading: true,
      };
    case GET_ALL_STATES_SUCCESS:
      return {
        ...state,
        allStatesLoading: false,
        states: action.payload,
      };
    case GET_ALL_STATES_FAILED:
      return {
        ...state,
        allStatesLoading: false,
        allStatesError: action.payload,
      };
    case ADD_STATE_START:
      return {
        ...state,
        addStateLoading: true,
      };
    case ADD_STATE_END:
      return {
        ...state,
        addStateLoading: false,
      };
    case ADD_STATE_FAILED:
      return {
        ...state,
        addStateLoading: false,
        addStateError: action.payload,
      };
    case VIEW_STATE_START:
      return {
        ...state,
        viewStateLoading: true,
      };
    case VIEW_STATE_SUCCESS:
      return {
        ...state,
        viewStateLoading: false,
        currentState: action.payload,
      };
    case VIEW_STATE_FAILED:
      return {
        ...state,
        viewStateLoading: false,
        viewStateError: action.payload,
      };
    case EDIT_STATE_START:
      return {
        ...state,
        editStateLoading: true,
      };
    case EDIT_STATE_END:
      return {
        ...state,
        editStateLoading: false,
      };
    case EDIT_STATE_SUCCESS:
      return {
        ...state,
        editStateLoading: false,
        currentState: action.payload,
      };
    case EDIT_STATE_FAILED:
      return {
        ...state,
        editStateLoading: false,
        editStateError: action.payload,
      };
    default:
      return state;
  }
}
